import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
/**
 * @description:这是一个Flux通用文生图模板
 * @param {string} galleryname
 * @param {string} positive
 * @param {string} loraname lora风格模型
 */

function fluxNormalTemp(loraname, positive, genParams, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename_1 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_2 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_3 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const filename_4 = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      1: {
        inputs: {
          vae_name: 'FLUX.1-vae.sft'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      2: {
        inputs: {
          X: [
            '5',
            0
          ],
          tips: '整数变量X'
        },
        class_type: 'Math_X变量值',
        _meta: {
          title: 'Math_X变量值'
        }
      },
      3: {
        inputs: {
          samples: [
            '8',
            0
          ],
          vae: [
            '1',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      4: {
        inputs: {
          text: [
            '7',
            0
          ],
          clip: [
            '21',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      5: {
        inputs: {
          seed: seed
        },
        class_type: 'ttN seed',
        _meta: {
          title: 'seed'
        }
      },
      6: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      7: {
        inputs: {
          boolean: true,
          on_true: [
            '6',
            0
          ],
          on_false: [
            '11',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      8: {
        inputs: {
          seed: [
            '2',
            0
          ],
          sampler: 'euler',
          scheduler: 'simple',
          steps: genParams.steps,
          guidance: genParams.guidance,
          max_shift: '',
          base_shift: '',
          denoise: '1.0',
          model: [
            '28',
            0
          ],
          conditioning: [
            '4',
            0
          ],
          latent_image: [
            '9',
            0
          ]
        },
        class_type: 'FluxSamplerParams+',
        _meta: {
          title: '🔧 Flux Sampler Parameters'
        }
      },
      9: {
        inputs: {
          width: genParams.absWidth,
          height: genParams.absWidth,
          batch_size: 4
        },
        class_type: 'EmptyLatentImage',
        _meta: {
          title: 'Empty Latent Image'
        }
      },
      11: {
        inputs: {
          text: positive
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      16: {
        inputs: {
          lora_name: 'Flux_Turbo/flux-turbo.safetensors',
          lora_strength: 1,
          model: [
            '26',
            0
          ]
        },
        class_type: 'NunchakuFluxLoraLoader',
        _meta: {
          title: 'Nunchaku FLUX.1 LoRA Loader'
        }
      },
      17: {
        inputs: {
          lora_name: loraname,
          lora_strength: 1,
          model: [
            '16',
            0
          ]
        },
        class_type: 'NunchakuFluxLoraLoader',
        _meta: {
          title: 'Nunchaku FLUX.1 LoRA Loader'
        }
      },
      21: {
        inputs: {
          model_type: 'flux',
          text_encoder1: 'clip_l.safetensors',
          text_encoder2: 't5xxl_fp8_e4m3fn.safetensors',
          t5_min_length: 512,
          use_4bit_t5: 'disable',
          int4_model: 'none'
        },
        class_type: 'NunchakuTextEncoderLoader',
        _meta: {
          title: 'Nunchaku Text Encoder Loader (Deprecated)'
        }
      },
      26: {
        inputs: {
          model_path: 'Nunchaku/svdq-int4_r32-flux.1-dev.safetensors',
          cache_threshold: 0.12000000000000000,
          attention: 'nunchaku-fp16',
          cpu_offload: 'disable',
          device_id: 0,
          data_type: 'bfloat16',
          i2f_mode: 'enabled'
        },
        class_type: 'NunchakuFluxDiTLoader',
        _meta: {
          title: 'Nunchaku FLUX DiT Loader'
        }
      },
      28: {
        inputs: {
          model: [
            '17',
            0
          ]
        },
        class_type: 'DifferentialDiffusion',
        _meta: {
          title: 'Differential Diffusion'
        }
      },
      44: {
        inputs: {
          images: [
            '3',
            0
          ]
        },
        class_type: 'ImageListToImageBatch',
        _meta: {
          title: 'Image List to Image Batch'
        }
      },
      45: {
        inputs: {
          index: 0,
          any: [
            '44',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      46: {
        inputs: {
          index: 1,
          any: [
            '44',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      47: {
        inputs: {
          index: 2,
          any: [
            '44',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      48: {
        inputs: {
          index: 3,
          any: [
            '44',
            0
          ]
        },
        class_type: 'easy indexAnything',
        _meta: {
          title: 'Index Any'
        }
      },
      49: {
        inputs: {
          filename: filename_1,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '45',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      50: {
        inputs: {
          filename: filename_2,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '46',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      51: {
        inputs: {
          filename: filename_3,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '47',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      52: {
        inputs: {
          filename: filename_4,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '48',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const temp = []
        if (promptInfo.status.status_str === 'success') {
          for (let i = 49; i < 53; i++) {
            temp.push(JSON.parse(promptInfo.prompt[promptIndex][i].inputs.filename)[0])
          }
          temp.forEach(async (item) => {
            const imagepath = genOssImage(item)
            imageList.push(imagepath)
          })
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        // this.processing = false
        // this.tips = false
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  fluxNormalTemp
}
